import { useEffect, useRef } from "react";

/**
 * useEffectが一度だけ実行することを保証するカスタムフック
 **/
export const useOnceCall = (callBack: () => void) => {
    const didLogRef = useRef(false);
    useEffect(() => {
        if (didLogRef.current === false) {
            didLogRef.current = true;
            callBack();
        }
    }, []);
};
